export default __webpack_public_path__ + "static/media/par-4.5f7a86c0.png";